import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/stylesheets/app.css'
import VModal from "vue-js-modal";
import router from './router'
import CONSTANTS from "@/store/constants";
import VueScrollactive from "vue-scrollactive";

Vue.use(VueScrollactive);
import store from './store'
import {
  FontAwesomeIcon,FontAwesomeLayers
} from '@fortawesome/vue-fontawesome'

import {
  library
} from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle, faCheckCircle, faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faTimes,
  faExternalLinkAlt,
  faArrowLeft,
  faCircle,
  faInfoCircle,
  faHandshake,
  faAddressCard,
  faEye,
  faShieldAlt,
  faCheck,
  faSpinner,
  faChevronRight,
  faExclamationTriangle,
  faChevronCircleRight
} from "@fortawesome/free-solid-svg-icons";

library.add(faTimes);
library.add(faTimesCircle);
library.add(faCircle);
library.add(farCircle);
library.add(faSpinner);
library.add(faArrowLeft);
library.add(faExternalLinkAlt);
library.add(faInfoCircle);
library.add(faHandshake);
library.add(faAddressCard);
library.add(faEye);
library.add(faCheckCircle);
library.add(faShieldAlt);
library.add(faCheck);
library.add(faChevronRight);
library.add(faExclamationTriangle);
library.add(faChevronCircleRight);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
var headElement = document.getElementsByTagName("head")[0];

var componentScriptElement = document.createElement("script");
let date = new Date();
let oneHourCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear()+""+date.getHours();
componentScriptElement.src = CONSTANTS.HH_COMPONENTS_URL + "/helphubcore.umd.min.js?v=" + oneHourCache;
headElement.appendChild(componentScriptElement);

var searchScriptElement = document.createElement("script");
searchScriptElement.src = CONSTANTS.ES_COMPONENTS_URL + "/enterprisesearchbundle.umd.min.js?v=" + oneHourCache;
headElement.appendChild(searchScriptElement);

var componentStyleElement = document.createElement("link");
componentStyleElement.type = "text/css";
componentStyleElement.rel = "stylesheet";
componentStyleElement.href = CONSTANTS.HH_COMPONENTS_URL + "/theme.css";
headElement.appendChild(componentStyleElement);
Vue.config.ignoredElements = ["help-hub-header", "enterprise-search"];

Vue.use(VModal, {
  dynamic: true
});
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');